import { Component } from '@angular/core';

@Component({
  selector: 'app-attender-chat-container',
  templateUrl: './attender-chat-container.component.html',
  styleUrl: './attender-chat-container.component.scss'
})
export class AttenderChatContainerComponent {

}
